import { CoreIcon } from '@autopass-web/mochi-icons';

import autoPartnerLogo from '../../assets/logo-autopartner.svg';
import carmochiLogo from '../../assets/logo-carmochi.svg';
import creditCardLogo from '../../assets/logo-creditcard.svg';
import easyWalletLogo from '../../assets/logo-easy-wallet.svg';
import jkoPayLogo from '../../assets/logo-jkopay.svg';
import linePayLogo from '../../assets/logo-line-pay.svg';
import twqrLogo from '../../assets/logo-twqr.png';
import styles from './icons.module.scss';

export const ApplePayIcon = () => {
  return (
    <div
      className={`${styles['apple-pay-button']} ${styles['apple-pay-button-white']}`}
    />
  );
};

export const LinePayIcon = () => {
  return <img style={{ height: 24 }} src={linePayLogo} alt="line_pay" />;
};

export const EasyWalletIcon = () => {
  return <img style={{ height: 28 }} src={easyWalletLogo} alt="easy_wallet" />;
};

export const JKOPayIcon = () => {
  return (
    <img
      className={styles['logo']}
      style={{ height: 36 }}
      src={jkoPayLogo}
      alt="jko_pay"
    />
  );
};

export const CreditCardIcon = () => {
  return <CoreIcon src={creditCardLogo} style={{ height: 26 }} />;
};

export const AutoPartnerIcon = () => {
  return (
    <img style={{ height: 22 }} src={autoPartnerLogo} alt="line-pay-logo" />
  );
};

export const CarmochiIcon = () => {
  return <img style={{ height: 22 }} src={carmochiLogo} alt="line-pay-logo" />;
};

export const TaiwanPayIcon = () => {
  return <img style={{ height: 22 }} src={twqrLogo} alt="twqr-logo" />;
};
